import * as actionTypes from "../actions/sessionActions";

const initialState = {
  loggedIn: false,
  user: {},
  verify_user: {},
  loginLoading: false,
  is_disclaimer_shown: false,
  show_email_varification: false,
  error: {},
  error_type: "",
  nested_menus: [],
  user_Permissions: [],
  user_permissions_raw: [],
  user_reporting: [],
  approval_notifications: [],
  current_page_permissions: [],
  noti_refresh_time: "5",
  shift_time: {},
  show_password_reset: false,
  redirect_to_login: false,
  reset_password_flag: false,
  otp_code: "",
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...initialState,
      };
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        user: {},
        verify_user: {},
        loginLoading: false,
        error: "",
        error_type: "",
        is_disclaimer_shown: false,
        show_email_varification: false,
        show_password_reset: false,
      };
    }
    case actionTypes.LOGIN_REQUEST:
      return {
        ...state,
        loginLoading: true,
        error: "",
        error_type: "",
        user: [],
        loggedIn: false,
        is_disclaimer_shown: false,
        redirect_to_login: false,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        user: action.payload,
        user_Permissions: action.user_Permissions,
        user_permissions_raw: action.user_permissions_raw,
        user_reporting: action.user_reporting,
        nested_menus: action.nested_menus,
        approval_notifications: action.approval_notifications,
        shift_time: action.shift_time,
        error: "",
        loggedIn: true,
        verify_user: {},
        error_type: "",
        is_disclaimer_shown: false,
        show_password_reset: false,
        redirect_to_login: false,
      };
    case actionTypes.SHOW_VARIFICATION_SCREEN:
      return {
        ...state,
        loginLoading: false,
        verify_user: action.userObj,
        show_email_varification: action.show_email_varification,
        error: "",
        loggedIn: false,
        error_type: "",
        show_password_reset: false,
        is_disclaimer_shown: false,
        redirect_to_login: true,
        reset_password_flag: action.reset_password_flag,
      };
    case actionTypes.RESET_SESSION:
      return {
        ...state,
        loggedIn: false,
        user: {},
        verify_user: {},
        loginLoading: false,
        is_disclaimer_shown: false,
        show_email_varification: false,
        error: "",
        error_type: "",
        nested_menus: [],
        user_Permissions: [],
        user_permissions_raw: [],
        user_reporting: [],
        approval_notifications: [],
        shift_time: {},
        current_page_permissions: [],
        reset_password_flag: false,
        otp_code: "",
      };
    case actionTypes.CURRENT_PAGE_PERMISSIONS:
      return {
        ...state,
        current_page_permissions: action.current_page,
      };
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loginLoading: false,
        user: [],
        loggedIn: false,
        verify_user: {},
        error: action.payload, // Ensure this is correctly received
        error_type: action.error_type, // Ensure this is correctly received
      };

    case actionTypes.SHOW_PASSWORD_RESET_SCREEN:
      return {
        ...state,
        loginLoading: false,
        verify_user: action.userObj,
        otp_code: action.otp_code,
        show_password_reset: action.show_password_reset,
        error: "",
        loggedIn: false,
        error_type: "",
        is_disclaimer_shown: false,
      };
    case actionTypes.REDIRECT_TO_LOGIN:
      return {
        ...state,
        loginLoading: false,
        redirect_to_login: true,
      };
    case actionTypes.HIDE_ERROR:
      return {
        ...state,
        loginLoading: false,
        error: "",
        error_type: "",
      };
    case actionTypes.HIDE_FEILD_VALIDATION_ERROR: {
      const updatedErrors = { ...state.error };
      delete updatedErrors[action.feild_key];

      return {
        ...state,
        loginLoading: false,
        error: updatedErrors,
      };
    }

    case actionTypes.TOKEN_EXPIRE:
      return {
        ...state,
        loggedIn: false,
        user: [],
      };
    case actionTypes.HIDE_DISCLAIMER:
      return {
        ...state,
        is_disclaimer_shown: true,
      };
    case actionTypes.SET_APPROVAL_NOTIFICATIONS: {
      return {
        ...state,
        approval_notifications: action.approval_notifications,
      };
    }
    case actionTypes.SET_NOTIFICATION_REFRESH_TIME: {
      return {
        ...state,
        noti_refresh_time: action.noti_refresh_time,
      };
    }

    // case actionTypes.UPDATE_USER_INFO:
    //   return {
    //     ...state,
    //     user: action.updated_user,
    //   }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
